import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const legacyProjectReleasesNoteRoute: InvariantRoute = {
	name: 'legacy-project-releases-note',
	path: '/jira/secure/ReleaseNote.jspa',
	query: ['projectId', 'version'],
};
